import dayjs from 'dayjs';

const formatPeriodEndpoint = (date: dayjs.Dayjs, format: string) => (
  format === 'dateTime' ? dayjs(date) : dayjs(date).format('YYYY-MM-DD')
);

export default formatPeriodEndpoint;
